'use client';

import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { getApolloClient } from '@utils/apollo';
import { getCachedToken } from '@config/authentication';
import { useEffect, useState } from 'react';

export interface IClarityProviderProps {
  children: React.ReactNode;
}

export const ApolloClientProvider = ({ children }: IClarityProviderProps) => {
  const [apolloClient, setApolloClient] = useState<ApolloClient<NormalizedCacheObject>>();

  useEffect(() => {
    setApolloClient(getApolloClient());
  }, [getCachedToken()]);

  if (!apolloClient) {
    return null;
  }

  return <ApolloProvider client={apolloClient as ApolloClient<NormalizedCacheObject>}>{children}</ApolloProvider>;
};
